import { useEffect, useState } from 'react';
import { getFinancialAdvisors } from '../redux-store/actions';
import { FinancialAdvisorListType, FinancialAdvisorType } from '../redux-store/types/mdms';
import { useDispatch } from 'react-redux';

export const useFinancialAdvisor = (): FinancialAdvisorType[] => {
  const [financialAdvisors, setFinancialAdvisors] = useState<FinancialAdvisorListType>({
    financialAdvisorsList: [],
  });
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (financialAdvisors.financialAdvisorsList?.length === 0) {
          const financialAdvisors = (await dispatch(
            getFinancialAdvisors()
          )) as unknown as FinancialAdvisorListType;
          setFinancialAdvisors(financialAdvisors);
        }
      } catch (error) {
        console.error('Error fetching Financial Advisor MDMS data:', (error as Error).message);
      }
    };

    fetchData();
  }, [financialAdvisors.financialAdvisorsList?.length]);

  return financialAdvisors.financialAdvisorsList;
};
